import { Injectable, inject } from '@angular/core';
import { SDKBaseEffect } from 'ets-fe-ng-sdk';
import { UtilityService } from '../services/utility.service';

@Injectable()
export abstract class BaseEffect extends SDKBaseEffect {
  public uS = inject(UtilityService);
}
